/* import __COLOCATED_TEMPLATE__ from './restrict-to-user-tickets.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import type HelpCenterSite from 'embercom/models/help-center-site';
import type AppService from 'embercom/services/app-service';

interface Args {
  selectedHelpCenter: HelpCenterSite;
}

interface Signature {
  Args: Args;
}

export default class TicketsPortalRestrictToUserTickets extends Component<Signature> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  @action
  toggleTicketsPortalRestrictToUserTickets() {
    this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets =
      !this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets;
  }

  get isTicketsPortalRestrictToUserTicketsEnabled() {
    return this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets;
  }

  get description() {
    if (this.appService.app.canUseTicketsPortalVisibilityPermissions) {
      return this.intl.t(
        'new-settings.helpdesk.tickets.tickets-portal.restrict-to-user-tickets.description-visibility-permissions',
      );
    }
    return this.intl.t(
      'new-settings.helpdesk.tickets.tickets-portal.restrict-to-user-tickets.description',
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpdesk::Tickets::TicketsPortal::RestrictToUserTickets': typeof TicketsPortalRestrictToUserTickets;
    'new-settings/helpdesk/tickets/tickets-portal/restrict-to-user-tickets': typeof TicketsPortalRestrictToUserTickets;
  }
}
